<template>
  <div v-on:keyup.esc="showModal = false">
    <button type="button" class="btn btn-sm btn-menu" @click="showModal = true">
      Resources <i class="fa fa-file-code" aria-hidden="true"></i>
    </button>

    <div v-show="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header text-center">
              <h3>Add resource</h3>
            </div>

            <div class="modal-body">
              <div class="tabs">
                <button
                  class="tabs__button"
                  :class="tab === 0 ? 'tabs__button--active' : ''"
                  @click="tab = 0"
                >
                  Stylesheets
                </button>
                <button
                  class="tabs__button"
                  :class="tab === 1 ? 'tabs__button--active' : ''"
                  @click="tab = 1"
                >
                  Scripts
                </button>
              </div>

              <div v-show="tab === 0">
                <div class="input-group">
                  <input
                    type="text"
                    class="input-group__input"
                    v-model="stylesheetInput"
                    placeholder="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
                  />
                  <button class="input-group__button" @click="addStylesheet">
                    Add
                  </button>
                </div>
                <div
                  class="lists"
                  v-for="item in $store.state.stylesheets"
                  :key="item"
                >
                  <p class="lists__text">{{ item }}</p>
                  <button class="lists__button" @click="removeStylesheet(item)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

              <div v-show="tab === 1">
                <div class="input-group">
                  <input
                    type="text"
                    class="input-group__input"
                    v-model="scriptInput"
                    placeholder="https://unpkg.com/react@17/umd/react.development.js"
                  />
                  <button class="input-group__button" @click="addScript">
                    Add
                  </button>
                </div>
                <div
                  class="lists"
                  v-for="item in $store.state.scripts"
                  :key="item"
                >
                  <p class="lists__text">{{ item }}</p>
                  <button class="lists__button" @click="removeScript(item)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-sm btn-danger" @click="showModal = false">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "add-resource-button",
  data() {
    return {
      showModal: false,
      tab: 0,
      stylesheetInput: "",
      scriptInput: "",
    };
  },
  methods: {
    addStylesheet() {
      if (this.stylesheetInput) {
        this.$store.commit("addStylesheet", this.stylesheetInput);
        this.stylesheetInput = "";
      }
    },
    addScript() {
      if (this.scriptInput) {
        this.$store.commit("addScript", this.scriptInput);
        this.scriptInput = "";
      }
    },
    removeStylesheet(item) {
      this.$store.commit("removeStylesheet", item);
    },
    removeScript(item) {
      this.$store.commit("removeScript", item);
    },
  },
};
</script>

<style scoped>
.tabs {
  display: flex;
  align-items: center;
  height: 48px;
}

.tabs__button {
  height: 100%;
  border: none;
  background: #fff;
  color: rgb(50, 49, 48);
  cursor: pointer;
  font-size: 14px;
  padding: 0px 8px;
  border-bottom: 2px white solid;
  margin-right: 16px;
}

.tabs__button:hover {
  background: rgb(243, 243, 243);
}

.tabs__button--active {
  border-bottom: 2px #dc3545 solid;
  font-weight: bold;
}

.input-group {
  display: flex;
  margin: 0px;
  padding: 0px !important;
  height: 32px;
  margin-bottom: 16px;
}

.input-group__input {
  flex-grow: 1;
  border: 1px solid rgb(96, 94, 92);
  border-radius: 2px;
  height: 32px;
  padding: 0px 8px;
  margin: 0px;
  font-size: 14px;
  color: rgb(50, 49, 48);
}

.input-group__input:focus {
  border: 2px solid #dc3545;
}

.input-group__button {
  height: 100%;
  border: none;
  background: rgb(243, 243, 243);
  color: rgb(50, 49, 48);
  cursor: pointer;
  font-size: 14px;
  padding: 0px 16px;
  margin-left: 8px;
}

.input-group__button:hover {
  font-weight: bold;
}

.lists {
  height: 42px;
  margin: 0;
  padding: 0;
  display: flex;
}

.lists__text {
  flex-grow: 1;
  margin: 0;
  padding: 0;
  color: rgb(50, 49, 48);
  font-size: 14px;
  padding: 8px;
  border-bottom: 1px solid rgb(243, 242, 241);
  height: 100%;
}

.lists__button {
  background: #fff;
  height: 100%;
  padding: 4px;
  color: #dc3545;
  border: none;
  cursor: pointer;
}
</style>